const emailDomain = 'voyd.center'

// Centralize all email references - feels pointless now but lets us reference by semantics and dynamically change the mapping
const emails = {
  privacy: `privacy@${emailDomain}`,
  support: `support@${emailDomain}`,
}

export default emails
